<template>
  <div class="dashboard-loan-history">
    <b-dropdown
      v-model="loanHistoryType"
      variant="white-secondary"
      toggle-class="dashboard-h3 toggle px-0"
      :text="widgetTitle"
    >
      <b-dropdown-item :active="loanHistoryType === 'past'" @click="loanHistoryType = 'past'">
        {{ $t("components.dashboard.loan_history.past") }}
      </b-dropdown-item>
      <b-dropdown-item :active="loanHistoryType === 'ongoing'" @click="loanHistoryType = 'ongoing'">
        {{ $t("components.dashboard.loan_history.ongoing") }}
      </b-dropdown-item>
      <b-dropdown-item
        :active="loanHistoryType === 'upcoming'"
        @click="loanHistoryType = 'upcoming'"
      >
        {{ $t("components.dashboard.loan_history.upcoming") }}
      </b-dropdown-item>
      <b-dropdown-item :active="loanHistoryType === 'waiting'" @click="loanHistoryType = 'waiting'">
        {{ $t("components.dashboard.loan_history.waiting") }}
      </b-dropdown-item>
    </b-dropdown>

    <div v-if="loans.length > 0" class="dashboard-loan-history__loans">
      <ul v-for="loan in loans" :key="loan.id" class="dashboard-loan-history__loans">
        <li class="dashboard-loan-history__loans__loan">
          <router-link :to="`/loans/${loan.id}`">{{ loan.loanable.name }}</router-link>
          <br />
          <span>{{ getZonedTimes(loan).departureAt | date }}</span>
          <br />
          <span v-if="loansIsBorrower[loan.id]">{{ loanableOwnerName(loan) }}</span>
          <span v-else>{{ loan.borrower_user.full_name }}</span>
          <br />
          <template v-if="loan.status === 'completed'">
            <span v-if="loansIsBorrower[loan.id]">
              {{
                $t("components.dashboard.loan_history.paid", {
                  amount: -loan.borrower_total | currency,
                })
              }}
            </span>
            <span v-else>
              {{
                $t("components.dashboard.loan_history.received", {
                  amount: loan.owner_total | currency,
                })
              }}
            </span>
          </template>
        </li>
      </ul>
    </div>
    <div v-else class="dashboard-loan-history__loans">
      <p class="muted">{{ $t("components.dashboard.loan_history.no_trips") }}</p>
    </div>
    <transition name="fade">
      <div v-if="$store.state.dashboard.loansLoading" style="height: 3rem">
        <layout-loading class="d-block" full-height />
      </div>
    </transition>
  </div>
</template>

<script>
import { currency } from "@/helpers/filters";
import { getZonedTimes } from "@/helpers/loanTimezones";
import { getOwner } from "@/helpers/permissions/loanables";
import { isBorrower } from "@/helpers/permissions/loans";

export default {
  name: "DashboardLoanHistory",
  props: {
    user: {
      type: Object,
      required: true,
    },
    ongoingLoans: {
      type: Array,
      required: true,
    },
    pastLoans: {
      type: Array,
      required: true,
    },
    upcomingLoans: {
      type: Array,
      required: true,
    },
    waitingLoans: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loanHistoryType: "past",
    };
  },
  computed: {
    loans() {
      switch (this.loanHistoryType) {
        case "upcoming":
          return this.upcomingLoans;
        case "waiting":
          return this.waitingLoans;
        case "ongoing":
          return this.ongoingLoans;
        case "past":
        default:
          return this.pastLoans;
      }
    },
    loansIsBorrower() {
      let loansIsBorrower = {};

      for (const loan of this.loans) {
        loansIsBorrower[loan.id] = isBorrower(this.user, loan);
      }

      return loansIsBorrower;
    },
    widgetTitle() {
      switch (this.loanHistoryType) {
        case "upcoming":
          return this.$t("components.dashboard.loan_history.titles.upcoming");
        case "waiting":
          return this.$t("components.dashboard.loan_history.titles.waiting");
        case "ongoing":
          return this.$t("components.dashboard.loan_history.titles.ongoing");
        case "past":
          return this.$t("components.dashboard.loan_history.titles.past");
        default:
          return this.$t("components.dashboard.loan_history.titles.default");
      }
    },
  },
  methods: {
    currency,
    getZonedTimes,
    loanableOwnerName(loan) {
      return getOwner(loan.loanable)?.full_name ?? "";
    },
  },
};
</script>

<style lang="scss">
.dashboard-loan-history {
  .toggle {
    display: flex;
    align-items: center;
  }
  .dropdown-item {
    line-height: 1.5rem;
  }

  &__loans,
  &__link {
    font-size: 13px;
  }

  &__loans {
    list-style-type: none;
    margin: 0;
    padding: 0;
    margin-bottom: 1rem;
  }
}
</style>
